interface PageDimensions { w: number; h: number; }

const PAGE_DIMENSIONS_PX: Record<string, PageDimensions> = {
  A4: { w: 794, h: 1123 },
  Letter: { w: 816, h: 1056 },
  Legal: { w: 816, h: 1344 }
};

export function getPageWidthPx(pageSize?: string | null, isLandscape?: boolean): number {
  const base = PAGE_DIMENSIONS_PX[pageSize ?? 'A4'] ?? PAGE_DIMENSIONS_PX['A4'];
  return isLandscape ? base.h : base.w;
}

const MM_PER_INCH = 25.4;
const PX_PER_INCH = 96;
export const DEFAULT_MARGINS = '0mm';
export const PREVIEW_MIN_PADDING_PX = 12;

export function marginsToPaddingPx(margins?: string | null, floorPx = 0): string {
  const value = margins?.trim() || DEFAULT_MARGINS;
  return value.replace(/(-?\d*\.?\d+)mm/g, (_, mm: string) => {
    const px = Math.max((parseFloat(mm) * PX_PER_INCH) / MM_PER_INCH, floorPx);
    return `${Math.round(px * 100) / 100}px`;
  });
}

export function buildPreviewResetCss(scope: string): string {
  return `
${scope} img { max-width: 100%; height: auto; display: block; image-rendering: -webkit-optimize-contrast; image-rendering: high-quality; }
${scope} figure.image, ${scope} span.image-inline { display: block; max-width: 100%; margin: 1em 0; }
${scope} figure.image figcaption { font-size: 0.875rem; color: #6b7280; text-align: center; margin-top: 4px; caption-side: bottom; display: table-caption; }
${scope} figure.image.image_resized,
${scope} figure.image.image_resized img,
${scope} figure.image img[style*="width"] { width: 100%; }
${scope} figure.table { display: block; margin: 1em 0; max-width: 100%; overflow-x: auto; width: 100%; flex: 0 0 auto; }
${scope} span.image-inline:has(img[width]), ${scope} span.image-inline:has(img[height]) { display: inline-block; width: auto; margin: 0; }
${scope} table { border-collapse: collapse; border-spacing: 0; max-width: 100%; width: 100%; table-layout: auto; }
${scope} table, ${scope} th, ${scope} td { border: 1px solid #bfbfbf; }
${scope} th, ${scope} td { padding: 4px 8px; vertical-align: top; }
${scope} th { background: #f5f5f5; font-weight: 600; }
${scope} table caption { caption-side: top; padding: 4px 0; font-weight: 600; }
${scope} *:not(table):not(thead):not(tbody):not(tr):not(td):not(th):not(colgroup):not(col) { overflow-wrap: anywhere; word-break: break-word; }
`;
}
